import { render, staticRenderFns } from "./EntityUnityBusiness.vue?vue&type=template&id=38a0ad42"
import script from "./EntityUnityBusiness.vue?vue&type=script&lang=ts"
export * from "./EntityUnityBusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports